/**
 * 连尚读书app，jsapi demo
 */
import utils from "./utils";
const $win = window;
class WkReader {
  constructor() {
    this.wkr = $win.WKR;
    if (!this.wkr) {
      try {
        // throw 'not find wkr object';
        // let exception = new CommonException('not find wkr object', 1);
        // throw exception;
        throw new Error('not find wkr object');
      } catch (e) {
        console.log(e);
      }
    }
  }

  isClient () {
    return this.haveWkR() || this._haveMethod('webkit.messageHandlers.getDeviceId')
  }

  haveWkR () {
    this.wkr = $win.WKR;
    // alert('this.wkr'+this.wkr);
    if (this.wkr) {
      return true;
    }
    return false;
  }

  onReader (call) {

  }

  /**
   * 获取安装app列表
   * @param {*} param0 
   */
  getInstallAppList () {
    //  const demoJson = "[\"com.snda.wifilocating\",\"com.snda.wifilocating\", \"com.moji.mjweather\"]";
    const demoJson = "[]";
    let listData = '';
    if (!this.haveWkR()) {
      listData = demoJson;
      return JSON.parse(listData);
    }
    if (!this.wkr.getInstalledApplications) {
      return JSON.parse(demoJson);
    }
    let list = this.wkr.getInstalledApplications();
    // alert(list);
    if (!list) {
      return JSON.parse(demoJson);
    }
    let jplist = JSON.parse(list);
    // alert(jplist);
    if (jplist.map) {
      return jplist;
    }
    return JSON.parse(demoJson);
  }



  /**
   * 返回包名
   */
  getPackageName (callback) {

    if (this.haveWkR()) {
      return this.getAndroidPKGName(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getPKGName')) {
      return this.getiOSPKGName(callback);
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }

    /**
   * 返回渠道
   */
     getChannel (callback) {

      if (this.haveWkR()) {
        return this.getChannelName(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getChannelName (callback) {
      if (this.haveWkR() && this.wkr.getChannel) {
        const channel = this.wkr.getChannel();
        if (typeof callback === 'function') {
          callback(channel);
        }
        return channel;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }

    getCPEMNew (callback) {
      if (this.haveWkR()) {
        return this.getCPEMValueNew(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getCPEMValueNew (callback) {
      if (this.haveWkR() && this.wkr.getExtensionEcpmBySceneId) {
        const getExtensionEcpm = this.wkr.getExtensionEcpmBySceneId('60');
        if (typeof callback === 'function') {
          callback(getExtensionEcpm);
        }
        return getExtensionEcpm;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }

    getCPEM (callback) {
      if (this.haveWkR()) {
        return this.getCPEMValue(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getCPEMValue (callback) {
      if (this.haveWkR() && this.wkr.getExtensionEcpm) {
        const getExtensionEcpm = this.wkr.getExtensionEcpm();
        if (typeof callback === 'function') {
          callback(getExtensionEcpm);
        }
        return getExtensionEcpm;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }

  getAndroidPKGName (callback) {
    if (this.haveWkR() && this.wkr.getPackageName) {
      const PackageName = this.wkr.getPackageName();
      if (typeof callback === 'function') {
        callback(PackageName);
      }
      return PackageName;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }
  getEnableXm () {
    if (this.haveWkR() && this.wkr.getEnableXm) {
      console.log('有getEnableXm方法');
      const enableXm = this.wkr.getEnableXm();
      return enableXm;
    } else {
      return '';
    }
  }
  reportExposureOrClick (bool, id) {
    if (this.haveWkR() && this.wkr.reportExposureOrClick) {
      console.log('有reportExposureOrClick方法');
      this.wkr.reportExposureOrClick(bool, id);
    }
  }
  getiOSPKGName (callback) {
    const methodName = '__getPKGName_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (PKGName) {
        const name = PKGName || '';
        if (typeof callback === 'function') {
          callback(name);
        }
        return name;
      };
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    window.webkit.messageHandlers.getPKGName.postMessage({ methodName: methodName });
  }

  /**
   * 返回设备ID
   */
  getDeviceId (callback) {
    if (this.haveWkR()) {
      return this.getAndroidDeviceId(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getDeviceId')) {
      this.getiOSDeviceId(callback);
      return '';
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }
  // android机获取DeviceId,同步
  getAndroidDeviceId (callback) {

    if (this.haveWkR() && this.wkr.getDeviceId) {
      const did = this.wkr.getDeviceId();
      // alert(JSON.stringify({did}));
      if (typeof callback === 'function') {
        callback(did);
      }
      return did;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  /**
   * ios获到getDeviceId,异步
   */
  getiOSDeviceId (callback) {
    const methodName = '__getDeviceId_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (DeviceId) {
        const did = DeviceId || '';
        if (typeof callback === 'function') {
          callback(did);
        }
      };
    }

    window.webkit.messageHandlers.getDeviceId.postMessage({ methodName: methodName });
  }

  /**
   * 返回机器IMEI
   */
  getIMEI () {
    if (!this.haveWkR()) {
      return '';
    }
    // alert(this.wkr.getImei);
    if (!this.wkr.getImei) {
      return '';
    }
    return this.wkr.getImei() || '';
  }

  // 返回用户的ID
  getUserId (callback) {
    if (this.haveWkR()) {
      return this.getAndroidUserId(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getUserId')) {
      return this.getIOSUserId(callback);
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  getAndroidUserId (callback) {
    let uid = '';
    if (this.haveWkR() && this.wkr.getUserId) {
      uid = this.wkr.getUserId();
      // alert(JSON.stringify({uid}));
    }
    if (typeof callback === 'function') {
      callback(uid);
    }
    return uid;
  }

  getIOSUserId (callback) {
    const methodName = '__getUserId_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (DeviceId) {
        const did = DeviceId || '';
        if (typeof callback === 'function') {
          callback(did);
        }
      };
    }

    window.webkit.messageHandlers.getUserId.postMessage({ methodName: methodName });
  }

  // 获取版本号
  getAppVersoinCode (callback) {
    if (this.haveWkR()) {
      return this.getAndroidVersoinCode(callback);
    } else if (this._haveMethod('webkit.messageHandlers.getVesionCode')) {
      this.getiOSAppVersoinCode(callback);
      return '';
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }

  
  loadBottomAd () {
    if (this.haveWkR() && this.wkr.loadBottomAd) {
      this.wkr.loadBottomAd();
    }
  }

  showBottomAd () {
    if (this.haveWkR() && this.wkr.showBottomAd) {
      this.wkr.showBottomAd();
    }
  }

  getAndroidVersoinCode (callback) {
    if (this.haveWkR() && this.wkr.getAppVersoinCode) {
      const AppVersoinCode = this.wkr.getAppVersoinCode();
      if (typeof callback === 'function') {
        callback(AppVersoinCode);
      }
      return AppVersoinCode;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }
  getiOSAppVersoinCode (callback) {
    $win['iOSAppVersoinCodecallback'] = callback
    const methodName = '__getVesionCode_callback__';
    if (!$win[methodName]) {
      $win[methodName] = function (VesionCode) {
        if (typeof $win['iOSAppVersoinCodecallback'] === 'function') {
          $win['iOSAppVersoinCodecallback'](VesionCode || '');
        }
      };
    }

    window.webkit.messageHandlers.getVesionCode.postMessage({ methodName: methodName });
  }

  getChargeResult (request_code, callback) {
    if (this.haveWkR() && this.wkr.getChargeResult) {
      const result = this.wkr.getChargeResult(request_code);
      if (typeof callback === 'function') {
        callback(result);
      }
      return result;
    }
  }

  getSignResult (request_code, callback) {
    if (this.haveWkR() && this.wkr.getSignResult) {
      const result = this.wkr.getSignResult(request_code);
      if (typeof callback === 'function') {
        callback(result);
      }
      return result;
    }
  }

  isSupportDeepCharge (callback) {
    if (this.haveWkR() && this.wkr.isSupportDeepCharge) {
      const result = this.wkr.isSupportDeepCharge();
      if (typeof callback === 'function') {
        callback(result);
      }
      return result;
    }
  }

  // 通过客户端获取服务端 隐私协议 开关是否打开 >191110
  checkPrivacyAgreementBeforeCharge () {
    if (this.haveWkR() && this.wkr.checkPrivacyAgreementBeforeCharge && this.wkr.isHasAgreePrivacyAgreement) {
      let result = this.wkr.checkPrivacyAgreementBeforeCharge();
      if (result) {
        // 开关打开了  获取用户是否已同意隐私协议 >191110
        let res = this.wkr.isHasAgreePrivacyAgreement();
        return res  // res true 用户已同意，false 用户不同意
      } else {
        // 开关没打开，不用管是都同意
        return true;
      }
    } else {
      // 老版本没有方法，不用管是否同意
      return true
    }
  }

  // 通过客户端获取服务端 隐私协议 开关是否打开 >191110
  setHasAgreePrivacyAgreement (flag) {
    if (this.haveWkR() && this.wkr.setHasAgreePrivacyAgreement) {
      this.wkr.setHasAgreePrivacyAgreement(flag);
    }
  }


  getIOSNeedRefresh (callback) {  // H5直接掉IOS支付，之后检查是否成功
    if (this._haveMethod('webkit.messageHandlers.getNeedRefresh')) {
      const methodName = '__getNeedRefresh_callback__';
      if (!$win[methodName]) {
        $win[methodName] = function (NeedRefresh) {
          if (typeof callback === 'function') {
            callback(NeedRefresh || '');
          }
        };
      }

      window.webkit.messageHandlers.getNeedRefresh.postMessage({ methodName: methodName });
    }
  }

  // 调用IOS客户端支付完成后，获取订单号
  getOrderId (callback) {  // H5直接掉IOS支付，之后检查是否成功
    if (this._haveMethod('webkit.messageHandlers.getOrderId')) {
      const methodName = '__getOrderId_callback__';
      if (!$win[methodName]) {
        $win[methodName] = function (OrderId) {
          if (typeof callback === 'function') {
            callback(OrderId || '');
          }
        };
      }

      window.webkit.messageHandlers.getOrderId.postMessage({ methodName: methodName });
    } else {
      console.log('没有webkit.messageHandlers.getOrderId方法')
    }
  }

  _haveMethod (methods_str, root = $win) {
    let methods = methods_str.split('.');
    let flag = true;
    let rootObj = root;
    methods.forEach(item => {
      if (rootObj[item]) {
        rootObj = rootObj[item];
      } else {
        flag = false;
      }
    });
    return flag;
  }


  // 刷新金额接口
  refreshAccountInfo () {
    if (this.haveWkR() && this.wkr.refreshAccountInfo) {
      return this.wkr.refreshAccountInfo();
    } else if (this._haveMethod('webkit.messageHandlers.refreshAccount')) {
      console.log('走了ios方法')
      window.webkit.messageHandlers.refreshAccount.postMessage({ methodName: 'refreshAccount' });
    } else {
      console.log('无方法')
    }
  }

  // 获取支付方式
  getUserPayConfig () {
    //获取客户端默认支付方式接口方法getDefaultPayWay，返回值”alipay” : 支付宝、”wechat” : 微信、”wifi” : wifi钱包，异常则返回空字符串””，190820版本后的版本可支持
    if (this.haveWkR() && this.wkr.getDefaultPayWay) {
      return this.wkr.getDefaultPayWay();
    }
    return ''
  }

  // 设置本地分享
  setShareData (dataString) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setShareData) {
      return;
    }
    return this.wkr.setShareData(dataString);
  }
  /**
   * 是否显示分享按钮
   * @param {*} type 0为隐藏，1为显示
   */
  setShareShowType (type = 0) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setShareShowType) {
      return;
    }
    type = parseInt(type);
    return this.wkr.setShareShowType(type);
  }

  setPageCode (code) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setPageCode) {
      return;
    }
    this.wkr.setPageCode(code);
  }

  setToolBarPosCode (code) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setToolBarPosCode) {
      return;
    }
    this.wkr.setToolBarPosCode(code);
  }

  setShareBtnItemCode (code) {
    if (!this.haveWkR()) {
      return '';
    }
    if (!this.wkr.setShareBtnItemCode) {
      return;
    }
    this.wkr.setShareBtnItemCode(code);
  }


  // 检查安卓登陆状态
  getIsLogin (callback) {
    let login = '';
    if (this.haveWkR() && this.wkr.isLogin) {
      login = this.wkr.isLogin();
      if (typeof callback === 'function') {
        callback(login || false);
      }
      return login || false;
    } else if (this._haveMethod('webkit.messageHandlers.isLogin')) {
      const methodName = '__isLogin_callback__';
      $win[methodName] = function (login) {
        if (typeof callback === 'function') {
          callback(login || false);
        }
      };
      window.webkit.messageHandlers.isLogin.postMessage({ methodName: methodName });
    } else {
      console.log('没有isLogin方法')
      callback('')
    }
  }


  // 获取安卓登陆toekn等信息
  getLoginInfo (callback) {
    let loginInfo = '';
    if (this.haveWkR() && this.wkr.getLoginInfo) {
      loginInfo = this.wkr.getLoginInfo();
    } else {
      console.log('没有getLoginInfo方法')
    }
    if (typeof callback === 'function') {
      callback(loginInfo);
    }
    return loginInfo;
  }

  // 调用登录
  goToLogin () {
    if (this.haveWkR() && this.wkr.gotoLogin) {
      console.log('有安卓 gotoLogin方法')
      this.wkr.gotoLogin();
      return true
    } else if (this._haveMethod('webkit.messageHandlers.gotoLogin')) {
      console.log('走了ios gotoLogin方法')
      window.webkit.messageHandlers.gotoLogin.postMessage({ methodName: 'gotoLogin' });
    } else {
      console.log('没有gotoLogin方法')
      return false
    }
  }

  // 告诉客户端抽奖抽到了vip，用于打点自定义事件
  vipActivateByLottery (itemcode, vipdays) {
    if (this.haveWkR() && this.wkr.vipActivateByLottery) {
      this.wkr.vipActivateByLottery(itemcode, vipdays);
    } else {
      console.log('没有vipActivateByLottery方法')
    }
  }

  // 获取 h5_token_key
  getTokenkeyWithH5 (callback) {
    if (this.haveWkR() && this.wkr.getTokenkeyWithH5) {
      let token_key = this.wkr.getTokenkeyWithH5()
      console.log(token_key, 'token_key_and');
      // console.log('有getTokenkeyWithH5方法', token_key)
      if (typeof callback === 'function') {
        callback(token_key);
      }
      return token_key;
    } else if (this._haveMethod('webkit.messageHandlers.getTokenkeyWithH5')){
      console.log('IOS 有getTokenkeyWithH5方法')
      const methodName = '__getTokenkeyWithH5_callback__'
      $win[methodName] = function (token_key) {
        console.log(token_key, 'token_key_ios');
        if (typeof callback === 'function') {
          callback(token_key || '');
        }
      };

      window.webkit.messageHandlers.getTokenkeyWithH5.postMessage({ methodName: methodName });
    } else{
      
      console.log('没有getTokenkeyWithH5方法， 从url拿，一般用于本地开发使用')
      let token_key = utils.getUrlParam('token_key')
      if (typeof callback === 'function') {
        callback(token_key || '');
      }
      return token_key || ''
    }
  }

  // 跳转客户端任何页面，主要用于tab
  goToPage (url) {
    if (this.haveWkR() && this.wkr.gotoMain) {
      let res = this.wkr.gotoMain(url);
      if (!res) {
        window.location.href = url
      }
    } else {
      console.log('没有gotoActivity方法，走href')
      window.location.href = url
    }
  }

  // 获取打点数据
  BuildEventParams () {
    let report = ''
    if (this.haveWkR() && this.wkr.buildEventParams) {
      report = this.wkr.buildEventParams();
    } else {
      report = ''
    }
    return report
  }

  // 获取当前环境 188还是246
  getHost (callback) {
    //通过客户端环境获取对应接口API的域名，http:// 格式，最后没有/，记得把https
    if (this.haveWkR() && this.wkr.getHost) {
      let host = this.wkr.getHost();
      console.log('host', host)
      if (typeof callback === 'function') {
        callback(host);
      }
      return host
    } else if (this._haveMethod('webkit.messageHandlers.getHost')) {
      const methodName = '__getHost_callback__'
      $win[methodName] = function (host) {
        console.log('host', host)
        if (typeof callback === 'function') {
          callback(host || '');
        }
      };

      window.webkit.messageHandlers.getHost.postMessage({ methodName: methodName });
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // showLoading
  showLoading () {
    if (this.haveWkR() && this.wkr.showLoading) {
      console.log('有showLoading')
      this.wkr.showLoading();
    } else if (this._haveMethod('webkit.messageHandlers.showLoading')) {
      // window.webkit.messageHandlers.showLoading.postMessage();
    }
  }
  // hideLoading
  hideLoading () {
    if (this.haveWkR() && this.wkr.hideLoading) {
      this.wkr.hideLoading();
    } else if (this._haveMethod('webkit.messageHandlers.hideLoading')) {
      // window.webkit.messageHandlers.hideLoading.postMessage();
    }
  }

  // closeWebView 关闭当前webview，code暂时没用，但是必须传
  closeWebView (code) {
    if (this.haveWkR() && this.wkr.closeWebView) {
      console.log('存在closeWebView方法')
      this.wkr.closeWebView(code);
    } else if (this._haveMethod('webkit.messageHandlers.closeWebView')) {
      window.webkit.messageHandlers.closeWebView.postMessage();
    }
  }


  showToast (str) {
    if (this.haveWkR() && this.wkr.showToast) {
      console.log('存在showToast方法')
      this.wkr.showToast(str);
    } else if (this._haveMethod('webkit.messageHandlers.showToast')) {
      window.webkit.messageHandlers.showToast.postMessage();
    }
  }

  // 告知客户端一些消息 {key: get_vip_result, value: "{"vip":1}"}
  notifyApp (str) {
    if (this.haveWkR() && this.wkr.notifyApp) {
      console.log('存在notifyApp方法')
      this.wkr.notifyApp(str);
    } else if (this._haveMethod('webkit.messageHandlers.notifyApp')) {
      window.webkit.messageHandlers.notifyApp.postMessage();
    }
  }



  // 调用微信分享，传base64图片
  sharePicToWx (data) {
    if (this.haveWkR() && this.wkr.shareImgToWx) {
      console.log('shareImgToWx存在')
      this.wkr.shareImgToWx(data)
    } else if (this._haveMethod('webkit.messageHandlers.getEarnShare')) {
      let post_data = ''
      let index = data.indexOf('base64,')
      if (index > -1) {
        post_data = data.slice(index + 7)
      }
      window.webkit.messageHandlers.getEarnShare.postMessage(post_data);
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 读书SDK分享到连信
  shareLinkToLxFriend (title, desc, linkurl, iconurl) {
    if (this.haveWkR() && this.wkr.shareLinkToLxFriend) {
      console.log('shareLinkToLxFriend存在')
      return this.wkr.shareLinkToLxFriend(title, desc, linkurl, iconurl)
    } else {
      return '';
    }
  }

  // 读书SDK分享到连信朋友圈
  shareLinkToLxMoments (title, linkurl, iconurl) {
    if (this.haveWkR() && this.wkr.shareLinkToLxMoments) {
      console.log('shareLinkToLxMoments存在')
      return this.wkr.shareLinkToLxMoments(title, linkurl, iconurl)
    } else {
      return '';
    }
  }

  // 大转盘的激励视频播放
  playTime () {
    if (this.haveWkR() && this.wkr.playTime) {
      console.log('存在playTime调用激励视频方法方法')
      this.wkr.playTime();
    }
  }

  // 通用的激励视频播放
  playRewardVideo (strjson,callback) {
    console.log('this.wkr',this.wkr)
    if (this.haveWkR() && this.wkr.playRewardVideo) {
      console.log('存在playRewardVideo调用激励视频方法方法')
      this.wkr.playRewardVideo(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.playRewardVideo')) {
        console.log('走了ios方法')
        const methodName = '__playRewardVideo_callback__';
        $win[methodName] = function (code) {
            console.log('code',code)
            if (typeof callback === 'function') {
                callback(code || false);
            }
        };
        window.webkit.messageHandlers.playRewardVideo.postMessage(strjson);
    } else {
        callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  // 通用的激励视频播放1
  playRewardVideoIphone (strjson,callback) {
    console.log('this.wkr',this.wkr)
    if (this.haveWkR() && this.wkr.playRewardVideo) {
      console.log('存在playRewardVideo调用激励视频方法方法')
      this.wkr.playRewardVideo(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.playRewardVideo')) {
        window.webkit.messageHandlers.playRewardVideo.postMessage(strjson);
    } else {
        callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  // 免广告激励视频播放
  cacheRewardVideo (strjson,callback) {
    if (this.haveWkR() && this.wkr.showCacheRewardVideo) {
      console.log('showCacheRewardVideo')
      this.wkr.showCacheRewardVideo(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.showCacheRewardVideo')) {
        console.log('走了ios方法')
        const methodName = '__showCacheRewardVideo_callback__';
        $win[methodName] = function (code) {
            console.log('code',code)
            if (typeof callback === 'function') {
                callback(code || false);
            }
        };
        window.webkit.messageHandlers.showCacheRewardVideo.postMessage(strjson);
    } else {
        callback && callback('')
      console.log('showCacheRewardVideoaaa')
        return ''
    }
  }

  playExtensionVideo (prizetype, prizeid, use_ecpm, callback) {
    if (this.haveWkR() && this.wkr.playExtensionVideo) {
      console.log('存在playExtensionVideo调用激励视频方法方法')
      console.log(prizetype, prizeid, use_ecpm, '值');
      this.wkr.playExtensionVideo(Number(prizetype), Number(prizeid), Number(use_ecpm));
    } else {
      callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  playH5CommonRewardVideo (prizetype, prizeid, use_ecpm, callback) {
    if (this.haveWkR() && this.wkr.playH5CommonRewardVideo) {
      console.log('激励视频调用成功');
      console.log(prizetype, 'prizetype');
      console.log(prizeid, 'prizeid');
      console.log(use_ecpm, 'use_ecpm');
      this.wkr.playH5CommonRewardVideo(Number(prizetype), Number(prizeid), Number(use_ecpm));
    } else {
      callback && callback('')
        return ''
    }
  }

  playTtsExtensionVideo (prizetype, prizeid, use_ecpm, callback) {
    if (this.haveWkR() && this.wkr.playTtsExtensionVideo) {
      console.log('存在playTtsExtensionVideo调用激励视频方法方法')
      console.log(prizetype, prizeid, use_ecpm, '值');
      this.wkr.playTtsExtensionVideo(Number(prizetype), Number(prizeid), Number(use_ecpm));
    } else {
      callback && callback('')
      console.log('没有playRewardVideo方法')
        return ''
    }
  }

  /**
   * 获取广告视频
   */
   getRewardVideo () {
     console.log('开始');
   if (this.haveWkR() && this.wkr.loadCacheRewardVideo) {
     console.log('开始调用loadCacheRewardVideo');
     this.wkr.loadCacheRewardVideo();
   }
 }

 /**
   * 取消刷新按钮
   */
  exitReshed (val) {
  if (this.haveWkR() && this.wkr.setRefreshBtn) {
    this.wkr.setRefreshBtn(val);
  }
}


  // 设置日历
  setCalender (strjson,callback) {
    console.log('this.wkr',this.wkr)
    if (this.haveWkR() && this.wkr.setCalender) {
      console.log('存在setCalender调用激励视频方法方法')
      this.wkr.setCalender(strjson);
    }else if (this._haveMethod('webkit.messageHandlers.setCalender')) {
        console.log('走了ios方法')
        const methodName = '__setCalender_callback__';
        $win[methodName] = function (code) {
            console.log('code',code)
            if (typeof callback === 'function') {
                callback(code || false);
            }
        };
        window.webkit.messageHandlers.setCalender.postMessage(strjson);
    } else {
        callback && callback('')
        console.log('没有setCalender方法')
        return ''
    }
  }

  // ios跳转页面
  goPage (url) {
    if (utils.isAndroid()) {
      window.open(url, '_blank')
    } else {
      if (this._haveMethod('webkit.messageHandlers.openPage')) {
        window.webkit.messageHandlers.openPage.postMessage({ methodName: 'openPage', url: url });
      }
    }
  }

  // ios跳转页面
  goPageOn (url) {
    console.log(url);
    if (utils.isAndroid()) {
      console.log(2);
      location.href = url
    } else {
      if (this._haveMethod('webkit.messageHandlers.openPage')) {
        window.webkit.messageHandlers.openPage.postMessage({ methodName: 'openPage', url: url });
      }
    }
  }


  // 修改安卓状态栏配置
  changeFullScreen (callback) {

    if (this.haveWkR()) {
      return this.changeAndroidFullScreen(callback);
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }

  changeAndroidFullScreen (callback) {
    if (this.haveWkR() && this.wkr.isOpenFullScreen) {
      const isOpenFullScreen = this.wkr.isOpenFullScreen(true);
      if (typeof callback === 'function') {
        callback(isOpenFullScreen);
      }
      return isOpenFullScreen;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 修改安卓状态栏配置
  changeFullScreenHidden (callback) {

    if (this.haveWkR()) {
      return this.changeAndroidFullScreenHidden(callback);
    }
    if (typeof callback === 'function') {
      callback('');
    }
    return '';
  }

  changeAndroidFullScreenHidden (callback) {
    if (this.haveWkR() && this.wkr.isOpenFullScreen) {
      const isOpenFullScreen = this.wkr.isOpenFullScreen(false);
      if (typeof callback === 'function') {
        callback(isOpenFullScreen);
      }
      return isOpenFullScreen;
    } else {
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }
  }

  // 金币掉落声音
  getCoinVoice () {
    if (this.haveWkR() && this.wkr.playGoldMusic) {
      this.wkr.playGoldMusic();
    }
  }

  // 设置日历
  setCalender (data) {
    if (this.haveWkR() && this.wkr.setCalender) {
      console.log('setCalender存在')
      return this.wkr.setCalender(data)
    } else {
      return '';
    }
  }

   /**
   * 返回渠道
   */
    getDeepLink (callback) {

      if (this.haveWkR()) {
        return this.getWelfareCenterTabDeeplink(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getWelfareCenterTabDeeplink (callback) {
      if (this.haveWkR() && this.wkr.getWelfareCenterTabDeeplink) {
        const deepLink = this.wkr.getWelfareCenterTabDeeplink();
        if (typeof callback === 'function') {
          callback(deepLink);
        }
        return deepLink;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }

    // 跳转金币商城
    enterCoinStore (channel) {
    if (this.haveWkR() && this.wkr.enterCoinStore) {
      this.wkr.enterCoinStore(channel);
    }
  }

   // 跳转
   enterAdxWithdraw () {
    if (this.haveWkR() && this.wkr.enterAdxWithdraw) {
      this.wkr.enterAdxWithdraw();
    }
  }

   /**
   * 展示顶部title
   */
    isShowWebTitle (callback) {

      if (this.haveWkR()) {
        return this.getisShowWebTitle(callback);
      }
      if (typeof callback === 'function') {
        callback('');
      }
      return '';
    }

    getisShowWebTitle (callback) {
      if (this.haveWkR() && this.wkr.isShowWebTitle) {
        const showWebTitle = this.wkr.isShowWebTitle();
        if (typeof callback === 'function') {
          callback(showWebTitle);
        }
        return showWebTitle;
      } else {
        if (typeof callback === 'function') {
          callback('');
        }
        return '';
      }
    }
}

const wkReader = function () {
  return new WkReader();
};
export default wkReader();


// WEBPACK FOOTER //
// ./src/common/js/wkreader.js